import { FC } from 'react';

import { FilterState } from '@/context/FilterProvider';
import { ModelingLayerType } from '@/typings/dbt';
import { toTitleCase } from '@/util/string';
import { BaseFilterToggle, FilterToggleProps } from './BaseFilterToggle';

interface ModelingLayerToggleProps extends FilterToggleProps {
  modelingLayerType: ModelingLayerType;
  onToggle: FilterState['updateFilters'];
  count?: number;
}

export const ModelingLayerToggle: FC<ModelingLayerToggleProps> = (props) => {
  const { modelingLayerType, isChecked, count } = props;

  const onToggle = () =>
    props.onToggle({ modelingLayer: [modelingLayerType] }, !isChecked);

  return (
    <BaseFilterToggle {...props} compact onToggle={onToggle} count={count}>
      <span className="flex-1">{toTitleCase(modelingLayerType)}</span>
    </BaseFilterToggle>
  );
};
